import DownloadAgentStatusLogIcon from '@mui/icons-material/CloudDownload';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { DatePicker } from '@mui/x-date-pickers';
import { DateTime } from 'luxon';
import React, { useState } from 'react';

import OberonDialog from '~components/OberonDialog';

type Props = {
  username: string;
};

const DownloadAgentStatusLogs = ({ username }: Props) => {
  const [open, setOpen] = useState(false);
  const onClose = () => setOpen(false);
  const currDate = DateTime.now();
  const [dateFrom, setDateFrom] = useState(currDate.minus({ days: 6 }));
  const [dateTo, setDateTo] = useState(currDate);
  const downloadAgentStatusLogsUrl = `/api/agents/${username}/stats/${dateFrom.toISODate()}/${dateTo.toISODate()}/download`;

  return (
    <>
      <Button
        fullWidth
        disableElevation
        variant='contained'
        size='small'
        onClick={() => setOpen((p) => !p)}
        startIcon={<DownloadAgentStatusLogIcon />}
        color='primary'
        title='Download'>
        Download
      </Button>
      <OberonDialog
        open={open}
        onClose={onClose}
        title='Download Agent Status Logs'
        content={
          <Grid container spacing={2}>
            <Grid
              size={{
                xs: 12,
                md: 6,
              }}>
              <DatePicker
                onChange={(dateFrom) => {
                  if (dateFrom) {
                    const maxDate = dateFrom.plus({ days: 29 });
                    setDateFrom(dateFrom);
                    if (dateTo < dateFrom) {
                      setDateTo(dateFrom);
                    } else if (maxDate < dateTo) {
                      setDateTo(maxDate);
                    }
                  }
                }}
                disableFuture
                format='DD'
                label='Date From'
                value={dateFrom}
                slotProps={{ textField: { fullWidth: true, variant: 'outlined', size: 'small' } }}
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 6,
              }}>
              <DatePicker
                onChange={(dateTo) => {
                  if (dateTo) {
                    const minDate = dateTo.minus({ days: 29 });
                    setDateTo(dateTo);
                    if (dateTo < dateFrom) {
                      setDateFrom(dateTo);
                    } else if (minDate > dateFrom) {
                      setDateFrom(minDate);
                    }
                  }
                }}
                disableFuture
                format='DD'
                label='Date To'
                value={dateTo}
                slotProps={{ textField: { fullWidth: true, variant: 'outlined', size: 'small' } }}
              />
            </Grid>
          </Grid>
        }
        actionFooter={
          <>
            <Button variant='text' onClick={onClose}>
              Close
            </Button>

            <Button
              download
              disableElevation
              color='primary'
              variant='contained'
              href={downloadAgentStatusLogsUrl}
              onClick={() => {
                setOpen(false);
              }}>
              Download
            </Button>
          </>
        }
      />
    </>
  );
};

export default DownloadAgentStatusLogs;
